import { styled } from '$utils/theme'
import { SizeName, Size } from '$utils/theme/size'
import { rem } from 'polished'

interface Props {
  columns: number
  rows: number
  columnGap?: SizeName
  rowGap?: SizeName
  alignItemsCentered?: boolean
  justifyContentCentered?: boolean
  columnFitContent?: boolean
}

export const StyledGrid = styled.div<Props>`
  display: grid;
  grid-template-columns: repeat(${p => p.columns}, ${p => (p.columnFitContent ? 'fit-content(100%)' : 'auto')});
  grid-template-rows: repeat(${p => p.rows}, auto);
  column-gap: ${p => p.columnGap && rem(Size[p.columnGap])};
  row-gap: ${p => p.rowGap && rem(Size[p.rowGap])};
  align-items: ${p => p.alignItemsCentered && 'center'};
  justify-content: ${p => p.justifyContentCentered && 'center'};
`



// WEBPACK FOOTER //
// ./src/views/components/Grid/Grid.style.ts